<!--
Important:
This Component is used only for the Vue3 application
Any modifications made should be done for Vue2 component also
Vue2File: wwwroot\js\WebsitePrimary\components\VehicleCount\BmwVehicleCount.vue
Dont forget to make the changes in both the files
Any clarifications contact Laxman
-->
<template>
  <div
    v-if="inventoryVehicledetails"
    class="container explore-by-models vehicle-inventory-slick-section g-page-section"
  >
    <h2 class="col-12 text-center mb-5 _theme_font_thin">
      {{ heading ? heading : "Explore by model" }}
    </h2>
    <div class="d-flex justify-content-center vehicle-type-selector">
      <div
        class="vehicle-filter-by-type d-md-flex justify-content-center text-center"
        style="border-bottom: 1px solid #707070"
      >
        <div
          class="px-4 mb-2 mb-md-0"
          :class="{ 'filterActive _theme_font_bolder': filterByIdValue == '3' }"
          @click="filterVehicles('3')"
        >
          SUVs
        </div>
        <div
          class="px-4 mb-2 mb-md-0"
          :class="{ 'filterActive _theme_font_bolder': filterByIdValue == '4' }"
          @click="filterVehicles('4')"
        >
          Sedans
        </div>
        <div
          class="px-4 mb-2 mb-md-0"
          :class="{ 'filterActive _theme_font_bolder': filterByIdValue == '2' }"
          @click="filterVehicles('2')"
        >
          Coupes
        </div>
        <div
          class="px-4 mb-2 mb-md-0"
          :class="{ 'filterActive _theme_font_bolder': filterByIdValue == '1' }"
          @click="filterVehicles('1')"
        >
          Convertibles
        </div>
        <div
          v-if="isBmw"
          class="px-4 mb-2 mb-md-0"
          :class="{
            'filterActive _theme_font_bolder': filterByIdValue == '5,6,7',
          }"
          @click="filterVehicles('5,6,7')"
        >
          BMW M
        </div>
        <div
          class="px-4 mb-2 mb-md-0"
          :class="{
            'filterActive _theme_font_bolder': filterByIdValue == '8,9,10',
          }"
          @click="filterVehicles('8,9,10')"
        >
          Electrified
        </div>
      </div>
      <div class="border-color-target" />
    </div>
    <VSlickCarousel
      v-if="inventoryVehicledetails.newModels.length && showBMWSlick"
      ref="vehicletypeidscountslick"
      v-bind="slickOptions"
      @afterChange="handleAfterChange"
    >
      <template #prevArrow="arrowSlotProps">
        <div
          v-if="showArrows"
          @click="
            slickDirection = 'previous';
            arrowSlotProps.onClick();
          "
          :disabled="arrowSlotProps.disabled"
        >
          <em class="primaryicon-left-arrow slick-arrow" style="cursor: pointer; z-index: 1"></em>
        </div>
      </template>
      <template #nextArrow="arrowSlotProps">
        <div
          v-if="showArrows"
          @click="
            slickDirection = 'next';
            arrowSlotProps.onClick();
          "
          :disabled="arrowSlotProps.disabled"
        >
          <em
            class="primaryicon-right-arrow slick-arrow"
            style="color: #cccccc; cursor: pointer; z-index: 1"
          ></em>
        </div>
      </template>
      <a
        v-for="(vehicle, index) in inventoryVehicledetails.newModels"
        :key="index"
        :href="`${vehicle.vehicles.url}`"
        class="bw-inventory-vehicle-block no-hover color-primary theme-text-color"
      >
        <div
          class="w-75 mx-auto d-flex justify-content-center align-items-center"
          style="height: 150px"
        >
          <img
            v-if="useoverrides"
            :src="`${vehicle.vehicles.photoURLs}&angle=03&width=350&colorcode=${vehicle.vehicles.extColorCode}&quality=85&useoverrides=${useoverrides}&type=jpeg`"
            class="img-fluid"
            :width="imageWidth"
            :height="imageHeight"
            :alt="`${vehicle.vehicles.year} ${vehicle.vehicles.make} ${vehicle.vehicles.model}`"
          />
          <img
            v-else
            :src="`${vehicle.vehicles.photoURLs}&angle=03&width=350&colorcode=${vehicle.vehicles.extColorCode}&quality=85&type=jpeg`"
            :width="imageWidth"
            :height="imageHeight"
            class="img-fluid"
            :alt="`${vehicle.vehicles.year} ${vehicle.vehicles.make} ${vehicle.vehicles.model}`"
          />
        </div>

        <div class="mt-4">
          <div
            translate="no"
            class="bw-vehicle-count-title text-center ft-24 _theme_font_bold font-weight-bold color-black"
          >
            {{ vehicle.vehicles.model }}
          </div>
        </div>
      </a>
    </VSlickCarousel>
    <!-- </slick> -->
    <div v-else class="text-center">
      <span class="text-uppercase _theme_font_bold letter-spacing-2 color-black"
        >No Vehicles Available</span
      >
    </div>
  </div>
</template>

<script type="text/javascript">
import VehicleCount from "./VehicleCount";
export default {
  mixins: [VehicleCount],
  data() {
    return {
      useoverrides: window.digiServiceUseOverrides,
      slickOptions: {
        infinite: true,
        slidesPerGroup: 1,
        groupsToShow: 1,
        groupsToScroll: 1,
        dots: false,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              groupsToShow: 3,
              groupsToScroll: 3,
            },
          },
          {
            breakpoint: 480,
            settings: {
              groupsToShow: 2,
              groupsToScroll: 2,
            },
          },
        ],
        nextArrow: `<em class="primaryicon-right-arrow" style="color:#cccccc;cursor:pointer;z-index:1"></em>`,
        prevArrow: `<em class="primaryicon-left-arrow" style="cursor:pointer;z-index:1"></em>`,
      },
      filterByIdValue: "3",
      filterByVehicleId: true,
      isGroupByModel: true,
      isBmw: window.make ? window.make.toLowerCase() === "bmw" : false,
    };
  },
};
</script>

<style scoped>
.vehicle-filter-by-type div {
  padding-bottom: 30px;
  border-bottom: 4px solid #fff;
  cursor: pointer;
}
.vehicle-filter-by-type div.filterActive {
  border-color: #000 !important;
  transition: all 0.3s ease-in-out;
}
.vehicle-type-selector {
  margin: 70px 0px;
}

.bw-inventory-vehicle-block:hover {
  cursor: pointer;
}

.img-ht {
  max-height: 100%;
}

@media (max-width: 700px) {
  .bw-inventory-vehicle-block {
    min-height: initial;
  }

  .count-img-box {
    position: initial !important;
  }
}
</style>
